
const links = document.querySelectorAll('a.js-smooth-scroll[href^="#"]');
for (let i = 0; i < links.length; i += 1) {
  links[i].addEventListener('click', e => {
    const target = document.querySelector(e.currentTarget.getAttribute('href'));
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth' });
    }
  })
}